'use client';

import { registerExperienceComponents } from './registerExperienceComponents';

export default function ExperienceComponents() {
  registerExperienceComponents();
  return null;
}
